// extracted by mini-css-extract-plugin
export default {"login":"css_login__1V6dF","button":"css_button__YlUVf","google":"css_google__qihLM","facebook":"css_facebook__WVDvV","result":"css_result__MlEN4","photo":"css_photo__gr+af"};